/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useNavigate } from "react-router-dom";
import { validate } from "uuid";

export function useUuidValidator(id: string) {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (validate(id) === false) {
      navigate("/404", { replace: true });
    }
  }, [navigate, id]);
}
